// Step 12 add-on G6.1 — ONE helper for the Cancel of "Replace the typed amount?" (STEP 11d · A6, lib/typedAmountConfirm.js).
// On Cancel the request is rejected with err._typedKept; every error formatter asks here first, so the screen shows the
// neutral "Not changed — the typed amount is kept." and never the 409 text — toErrMsg (lib/api.js) and errText
// (lib/i18n/1250_b34g.js) alike. Before, the errText screens (cut-off worksheet, W9, related parties …) showed the 409 detail.
import I18N from "@/lib/i18n/1995_s11d1b_finance";

const lang = () => {
  try { return (typeof localStorage !== "undefined" && localStorage.getItem("af_lang")) === "ar" ? "ar" : "en"; } catch { return "en"; }
};

export function typedKeptText(lng) {
  return I18N[lng || lang()].s11d1b.amount.kept;
}

/** The neutral text when the user cancelled the typed-amount confirm, else null (the caller formats the error as usual). */
export function typedKeptMessage(err, lng) {
  return err && err._typedKept ? typedKeptText(lng) : null;
}
